class SubscriptionWidget extends HTMLElement {
  constructor() {
    super();
    this.sectionId = this.dataset.sectionId;
    this.els();
    this.settings();
    this.listeners();
    this.isSubscriptionSelected = this.isSubscriptionSelected || this.subscriptionOptionEl && this.subscriptionOptionEl.classList.contains(this.activeClass);
  }

  variantChangeUnsubscriber = undefined;

  connectedCallback() {
    this.getVariantsData();
    this.getExtraSavingsData();

    if (!this.currentVariant) {
      this.currentVariantId = this.pdpEl.querySelector('[name="id"]').value;
      this.currentVariant = this.variants.find(v => v.id === parseFloat(this.currentVariantId));
    }

    this.updateExtraSavings();

    this.variantChangeUnsubscriber = window.subscribe(PUB_SUB_EVENTS.variantChange, event => {
      if (event.sectionId !== this.sectionId) return;
      this.currentVariant = event.currentVariant;
      this.onVariantChange();
    });
  }

  disconnectedCallback() {
    const unsubscribers = [
      this.swatchUnsubscriber,
      this.uomChangeUnsubscriber,
      this.variantChangeUnsubscriber,
    ];

    unsubscribers.forEach(unsubscriber => unsubscriber && unsubscriber());
  }

  getExtraSavingsData() {
    this.extraSavingsData = JSON.parse(this.querySelector('[data-json="extra-savings"]').textContent);
  }

  getVariantsData() {
    this.pdpEl = this.pdpEl || this.closest('product-detail');
    this.radioEls = this.pdpEl.querySelector('variant-radios');
    this.variants = this.pdpEl.variants || this.radioEls ? this.radioEls.getVariantData() : null;
  }

  settings() {
    this.activeClass = 'subcription-option--active';
    this.activeIndex = this.getActiveIndex();
    this.activeInputEl = this.inputEls[this.activeIndex];
    this.activeOptionEl = this.optionEls[this.activeIndex];
    this.orderTypeOption = this.dataset.orderTypeOption;
    this.sizeOption = this.dataset.sizeOption;
    if (this.pdpEl) {
      this.getVariantsData();
    }
  }

  els() {
    this.pdpEl = this.closest('product-detail');
    this.formEl = this.pdpEl.querySelector(`#productForm-${this.sectionId} form`);
    this.inputEls = this.querySelectorAll('[data-subscription-option-input]');
    this.optionEls = this.querySelectorAll('[data-subscription-option]');
    this.optionSubscriptionEl = this.pdpEl.querySelector('[data-product-radio-label="subscription"]');
    this.optionOneTimeEl = this.pdpEl.querySelector('[data-product-radio-label="one-time"]');
    this.subscriptionOptionEl = this.querySelector('[data-subscription-option="subscription"]');
    this.subscriptionTermsCloseEl = this.querySelector('[data-modal-subscription-terms-close]')
    this.subscriptionTermsOpenEl = this.querySelector('[data-modal-subscription-terms-open]')
    this.subscriptionTermsEl = this.querySelector('[data-modal-subscription-terms]')
  }

  getActiveIndex() {
    let activeIndex = null;

    this.optionEls.forEach((el, index) => {
      if (el.classList.contains(this.activeClass)) activeIndex = index;
    });

    return activeIndex;
  }

  getMatchingSubscription() {
    // when one time is active, get matching subscription variant
    if (this.isSubscriptionSelected) return this.currentVariant;
    return this.variants.find(v => v[this.sizeOption] === this.currentVariant[this.sizeOption] && v[this.orderTypeOption] === 'Subscription');
  }

  listeners() {
    this.rechargeRendered();

    this.optionEls.forEach((el, index) => {
      el.addEventListener('click', e => {
        // updated checked input
        this.activeInputEl.removeAttribute('checked');
        this.activeInputEl = this.inputEls[index];
        this.activeInputEl.checked = true;
        this.activeInputEl.dispatchEvent(new Event('input'), { bubbles: true });
      });
    });

    this.inputEls.forEach((el, index) => {
      el.addEventListener('input', e => {
        // remove previous active state
        this.activeOptionEl.classList.remove(this.activeClass);

        // add new active state
        this.optionEls[index].classList.add(this.activeClass);
        this.activeInputEl = this.inputEls[index];
        this.activeOptionEl = this.optionEls[index];

        this.orderType = this.activeOptionEl.dataset.subscriptionOption;
        this.isSubscriptionSelected = this.orderType === 'subscription';
        this.isSubscriptionSelected ? this.optionSubscriptionEl.click() : this.optionOneTimeEl.click();
      });
    });

    this.subscriptionTermsCloseEl.addEventListener('click', e => {
      this.subscriptionTermsEl.close();
    });

    this.subscriptionTermsOpenEl.addEventListener('click', e => {
      this.subscriptionTermsEl.showModal();
    });
  }

  removeSellingPlanProps() {
    this.formEl.querySelectorAll('[name*="selling_plan"]').forEach(el => {
      //el.removeAttribute('name')
      el.setAttribute('value', '')
    });
  }

  onVariantChange() {
    requestAnimationFrame(() => {
      this.sellingPlanIdEl = this.sellingPlanIdEl || this.formEl.querySelector('[name="selling_plan"]');

      // Add the selling_plan input to product form if needed
      if (!this.sellingPlanIdEl) {
        this.sellingPlanIdEl = document.createElement('input');
        this.sellingPlanIdEl.setAttribute('type', 'hidden');
        this.formEl.appendChild(this.sellingPlanIdEl)
      }

      if (!this.currentVariant) {
        // no subscription for this option, default back to One-Time
        this.optionOneTimeEl.click();
      }

      const hasSellingPlan = this.currentVariant?.selling_plan_allocations && this.currentVariant.selling_plan_allocations.length > 0;
      if (!hasSellingPlan) {
        this.optionSubscriptionEl.classList.add('hide');
        this.removeSellingPlanProps();
      } else {
        this.optionSubscriptionEl.classList.remove('hide');
      }

      if (this.isSubscriptionSelected) {
        // @TODO: add support for multiple selling plans (theres no products with multiple plans yet...)
        if (hasSellingPlan) {
          const sellingPlanId = this.currentVariant.selling_plan_allocations[0].selling_plan_id;
          this.formEl.querySelector('[name="selling_plan"]')?.setAttribute('name', 'selling_plan');
          this.formEl.querySelector('[data-quickview-recharge-selling-plan-input]')?.setAttribute('name', `selling_plan_${sellingPlanId}`);
          this.sellingPlanIdEl.setAttribute('name', 'selling_plan');
          this.sellingPlanIdEl.value = sellingPlanId;
        } else {
          // this option has no subscription selling plans, hide the subscription option and select one-item
          this.optionSubscriptionEl.classList.add('hide');
          this.optionOneTimeEl.click();
          this.removeSellingPlanProps();
        }
      } else {
        this.removeSellingPlanProps();
      }
    });
  }

  rechargeRendered() {
    const observerCallback = () => {
      const rechargeEl = this.formEl.querySelector('[data-plans-dropdown]');
      if (!rechargeEl) return;

      // make sure after recharge is added to form it doesnt have selling_plan when One-Time is selected
      if (!this.isSubscriptionSelected) {
        requestAnimationFrame(() => {
          //this.removeSellingPlanProps();
        });
      }

      this.observer.disconnect();
    };

    this.observer = new MutationObserver(observerCallback);
    this.observer.observe(this.formEl, {
      attributes: true,
      childList: true,
      subtree: true,
    });
  }

  updateExtraSavings() {
    const amount = this.extraSavingsData[this.getMatchingSubscription()?.id]?.extra_savings;
    if (!amount) return;
    const savingsEl = this.querySelector('[data-extra-savings]');
    if (savingsEl) savingsEl.innerText = amount;
  }
}

if (!customElements.get('subscription-widget')) {
  customElements.define('subscription-widget', SubscriptionWidget);
}